(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gender-selection"] && !Shopify.designMode) return;
  try {
    
  class GenderSelection {
    constructor() {
      this.genderLinks = document.querySelectorAll('[data-gender-filter]');
      this.init();
    }
    
    init() {
      this.genderLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          // Let the native link navigation handle the filter
          // The URL format ?filter.p.tag=boys/girls will work with Shopify's native filtering
        });
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    new GenderSelection();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
console.log('Header JavaScript is loading...');

class ToysLabHeader {
    constructor(element) {
      console.log('ToysLabHeader constructor called with:', element);
      this.element = element;
      this.mobileToggle = this.element.querySelector('[data-mobile-toggle]');
      this.mobileMenu = this.element.querySelector('[data-mobile-menu]');
      this.mobileOverlay = this.element.querySelector('[data-mobile-overlay]');
      this.searchToggle = this.element.querySelector('[data-search-toggle]');
      this.searchForm = this.element.querySelector('[data-search-form]');
      this.menuItems = this.element.querySelectorAll('.header__menu-item');
      
      console.log('Header elements found:');
      console.log('- Mobile toggle:', this.mobileToggle);
      console.log('- Mobile menu:', this.mobileMenu);
      console.log('- Search toggle:', this.searchToggle);
      console.log('- Search form:', this.searchForm);
      
      this.init();
    }
    
    init() {
      this.setupMobileMenu();
      this.setupSearch();
      this.setupSubmenuToggle();
      this.setupScrollEffect();
    }
    
    setupMobileMenu() {
      // Skip mobile menu setup - handled by simple script above
      // This prevents double event listeners
      return;
    }
    
    closeMobileMenu() {
      if (this.mobileToggle) {
        this.mobileToggle.setAttribute('aria-expanded', 'false');
      }
      if (this.mobileMenu) {
        this.mobileMenu.classList.remove('active');
      }
      if (this.mobileOverlay) {
        this.mobileOverlay.classList.remove('active');
      }
      document.body.style.overflow = '';
    }
    
    setupSearch() {
      console.log('Setting up search...');
      console.log('Search toggle:', this.searchToggle);
      console.log('Search form:', this.searchForm);
      
      if (!this.searchToggle || !this.searchForm) {
        console.warn('Search elements not found');
        return;
      }
      
      this.searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Search toggle clicked');
        
        this.searchForm.classList.toggle('active');
        console.log('Search form active:', this.searchForm.classList.contains('active'));
        
        if (this.searchForm.classList.contains('active')) {
          const input = this.searchForm.querySelector('input');
          setTimeout(() => input.focus(), 100);
        }
      });
      
      document.addEventListener('click', (e) => {
        if (!this.searchForm.contains(e.target) && !this.searchToggle.contains(e.target)) {
          this.searchForm.classList.remove('active');
        }
      });
    }
    
    setupSubmenuToggle() {
      this.menuItems.forEach(item => {
        const link = item.querySelector('.header__menu-link');
        const submenu = item.querySelector('.header__submenu');
        
        if (submenu && window.innerWidth <= 768) {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            item.classList.toggle('active');
          });
        }
      });
    }
    
    setupScrollEffect() {
      let lastScrollY = window.scrollY;
      
      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        
        if (currentScrollY > 100) {
          this.element.classList.add('header--scrolled');
        } else {
          this.element.classList.remove('header--scrolled');
        }
        
        if (window.innerWidth > 768) {
          if (currentScrollY > lastScrollY && currentScrollY > 200) {
            this.element.style.transform = 'translateY(-100%)';
          } else {
            this.element.style.transform = 'translateY(0)';
          }
        } else {
          this.element.style.transform = 'translateY(0)';
        }
        
        lastScrollY = currentScrollY;
      });
    }
  }
  
function initializeHeaders() {
  console.log('initializeHeaders called');
  const headers = document.querySelectorAll('.header[data-header]');
  console.log('Found headers:', headers.length);
  
  headers.forEach(header => {
    console.log('Initializing header:', header);
    try {
      new ToysLabHeader(header);
      console.log('Header initialized successfully');
    } catch (error) {
      console.error('Error initializing header:', error);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing headers...');
  initializeHeaders();
});

if (document.readyState === 'loading') {
  console.log('Document still loading, waiting for DOMContentLoaded');
} else {
  console.log('Document already loaded, initializing headers immediately');
  initializeHeaders();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(element) {
      this.element = element;
      this.currentSlide = 0;
      this.slides = element.querySelectorAll('.hero-slide');
      this.totalSlides = this.slides.length;
      this.autoplay = element.dataset.autoplay === 'true';
      this.interval = parseInt(element.dataset.interval) || 4000;
      this.autoplayTimer = null;
      
      this.init();
    }
    
    init() {
      if (this.totalSlides <= 1) return;
      
      this.setupEventListeners();
      this.showSlide(0);
      
      if (this.autoplay) {
        this.startAutoplay();
      }
      
      // Pause autoplay on hover
      this.element.addEventListener('mouseenter', () => this.stopAutoplay());
      this.element.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });
    }
    
    setupEventListeners() {
      // Arrow navigation
      const prevBtn = this.element.querySelector('[data-slider-prev]');
      const nextBtn = this.element.querySelector('[data-slider-next]');
      
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.prevSlide();
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.nextSlide();
        });
      }
      
      // Dot navigation
      const dots = this.element.querySelectorAll('[data-slide-to]');
      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const slideIndex = parseInt(e.target.dataset.slideTo);
          this.goToSlide(slideIndex);
        });
      });
      
      // Touch/swipe support
      let startX = 0;
      let endX = 0;
      
      this.element.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });
      
      this.element.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        this.handleSwipe();
      });
      
      const handleSwipe = () => {
        const threshold = 50;
        const diff = startX - endX;
        
        if (Math.abs(diff) > threshold) {
          if (diff > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }
      };
      
      this.handleSwipe = handleSwipe;
    }
    
    showSlide(index) {
      // Remove active class from all slides and dots
      this.slides.forEach(slide => slide.classList.remove('active'));
      const dots = this.element.querySelectorAll('.hero-slider__dot');
      dots.forEach(dot => dot.classList.remove('hero-slider__dot--active'));
      
      // Add active class to current slide and dot
      if (this.slides[index]) {
        this.slides[index].classList.add('active');
      }
      
      if (dots[index]) {
        dots[index].classList.add('hero-slider__dot--active');
      }
      
      this.currentSlide = index;
    }
    
    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.totalSlides;
      this.goToSlide(nextIndex);
    }
    
    prevSlide() {
      const prevIndex = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
      this.goToSlide(prevIndex);
    }
    
    goToSlide(index) {
      this.showSlide(index);
      this.restartAutoplay();
    }
    
    startAutoplay() {
      if (!this.autoplay || this.totalSlides <= 1) return;
      
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.interval);
    }
    
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
    
    restartAutoplay() {
      this.stopAutoplay();
      if (this.autoplay) {
        this.startAutoplay();
      }
    }
  }
  
  // Initialize slider
  function initSliders() {
    const sliders = document.querySelectorAll('.hero-slider');
    sliders.forEach(slider => {
      if (!slider.dataset.initialized) {
        new HeroSlider(slider);
        slider.dataset.initialized = 'true';
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
class CartPage {
  constructor() {
    this.cartForm = document.querySelector('[data-cart-form]');
    this.quantityInputs = document.querySelectorAll('[data-quantity-input]');
    this.quantityButtons = document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]');
    this.removeButtons = document.querySelectorAll('[data-remove-item]');
    this.updateButton = document.querySelector('[data-cart-update]');
    
    this.init();
  }
  
  init() {
    this.setupQuantityControls();
    this.setupRemoveButtons();
    this.setupAutoUpdate();
  }
  
  setupQuantityControls() {
    this.quantityButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        const itemKey = button.dataset.quantityMinus || button.dataset.quantityPlus;
        const input = document.querySelector(`[data-quantity-input="${itemKey}"]`);
        
        if (!input) return;
        
        const currentValue = parseInt(input.value) || 1;
        let newValue = currentValue;
        
        if (button.dataset.quantityMinus) {
          newValue = Math.max(0, currentValue - 1);
        } else if (button.dataset.quantityPlus) {
          newValue = currentValue + 1;
        }
        
        input.value = newValue;
        
        // Update minus button state
        const minusBtn = document.querySelector(`[data-quantity-minus="${itemKey}"]`);
        if (minusBtn) {
          minusBtn.disabled = newValue <= 1;
        }
        
        // Auto-update cart
        this.updateCart();
      });
    });
    
    // Handle direct input changes
    this.quantityInputs.forEach(input => {
      input.addEventListener('change', () => {
        const value = parseInt(input.value) || 0;
        const itemKey = input.dataset.quantityInput;
        
        // Update minus button state
        const minusBtn = document.querySelector(`[data-quantity-minus="${itemKey}"]`);
        if (minusBtn) {
          minusBtn.disabled = value <= 1;
        }
        
        this.updateCart();
      });
    });
  }
  
  setupRemoveButtons() {
    this.removeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        const itemKey = button.dataset.removeItem;
        const input = document.querySelector(`[data-quantity-input="${itemKey}"]`);
        
        if (input) {
          input.value = 0;
          this.updateCart();
        }
      });
    });
  }
  
  setupAutoUpdate() {
    if (this.updateButton) {
      this.updateButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.updateCart();
      });
    }
  }
  
  updateCart() {
    if (!this.cartForm) return;
    
    // Show loading state
    this.setLoadingState(true);
    
    // Submit form
    fetch('/cart/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(new FormData(this.cartForm))
    })
    .then(response => response.json())
    .then(cart => {
      // Reload page to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      this.setLoadingState(false);
    });
  }
  
  setLoadingState(loading) {
    if (this.updateButton) {
      this.updateButton.disabled = loading;
      this.updateButton.textContent = loading ? 'Updating...' : 'Update Cart';
    }
    
    // Disable quantity controls during update
    this.quantityButtons.forEach(btn => btn.disabled = loading);
    this.quantityInputs.forEach(input => input.disabled = loading);
  }
}

// Initialize cart page
document.addEventListener('DOMContentLoaded', () => {
  new CartPage();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class CollectionFilters {
    constructor() {
      this.filtersToggle = document.querySelector('[data-filters-toggle]');
      this.filtersContent = document.querySelector('[data-filters-content]');
      this.sortSelect = document.getElementById('sort-by');
      
      this.init();
    }
    
    init() {
      this.setupMobileToggle();
      this.setupSort();
      this.setupPriceRangeSliders();
    }
    
    setupMobileToggle() {
      // Handled by dedicated inline script below to avoid bundling timing issues
    }
    
    setupPriceRangeSliders() {
      const priceRanges = document.querySelectorAll('[data-price-range]');
      if (priceRanges.length === 0) return;
      
      priceRanges.forEach((priceRange) => {
        const minInput = priceRange.querySelector('[data-min-input]');
        const maxInput = priceRange.querySelector('[data-max-input]');
        const minDisplay = priceRange.querySelector('[data-min-display]');
        const maxDisplay = priceRange.querySelector('[data-max-display]');
        const rangeFill = priceRange.querySelector('[data-range-fill]');
        
        if (!minInput || !maxInput) return;
        
        // Get parameter names for price filters
        const minParam = minInput.getAttribute('name');
        const maxParam = maxInput.getAttribute('name');
        
        // Format currency value for display with currency icon
        // Using inline SVG for mobile compatibility
        const currencyIconSvg = '<img src="{{ "riyal.svg" | asset_url }}" class="money-riyal__icon-img" width="16" height="16" alt="" aria-hidden="true" style="display:inline-block;width:1em;height:1em;vertical-align:middle;">';
        const formatCurrency = (value) => {
          const numValue = parseFloat(value);
          return numValue.toFixed(2) + ' <span class="money-riyal__icon">' + currencyIconSvg + '</span>';
        };
        
        const updateSlider = () => {
          const min = parseFloat(minInput.min);
          const max = parseFloat(maxInput.max);
          let minVal = parseFloat(minInput.value);
          let maxVal = parseFloat(maxInput.value);
          
          // Ensure min doesn't exceed max
          if (minVal > maxVal - 1) {
            minVal = maxVal - 1;
            minInput.value = minVal;
          }
          
          // Ensure max doesn't go below min
          if (maxVal < minVal + 1) {
            maxVal = minVal + 1;
            maxInput.value = maxVal;
          }
          
          // Update display values with proper formatting
          if (minDisplay) {
            minDisplay.innerHTML = formatCurrency(minVal);
          }
          if (maxDisplay) {
            maxDisplay.innerHTML = formatCurrency(maxVal);
          }
          
          // Update range fill visual
          if (rangeFill) {
            const leftPercent = ((minVal - min) / (max - min)) * 100;
            const rightPercent = ((maxVal - min) / (max - min)) * 100;
            
            rangeFill.style.left = leftPercent + '%';
            rangeFill.style.width = (rightPercent - leftPercent) + '%';
          }
        };
        
        // Initialize slider
        updateSlider();
        
        minInput.addEventListener('input', updateSlider);
        maxInput.addEventListener('input', updateSlider);
        
        let debounceTimer;
        const applyPriceFilter = () => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            const url = new URL(window.location);
            
            // Preserve existing filter parameters (except price range)
            const filterParams = new URLSearchParams();
            url.searchParams.forEach((value, key) => {
              // Keep all filters except the price range parameters
              if (key.startsWith('filter.') && key !== minParam && key !== maxParam) {
                filterParams.append(key, value);
              }
            });
            
            // Clear all params and re-add non-price filters
            url.search = '';
            filterParams.forEach((value, key) => {
              url.searchParams.append(key, value);
            });
            
            // Add price range parameters
            // Shopify expects price values in cents, so multiply by 100
            const minVal = parseFloat(minInput.value);
            const maxVal = parseFloat(maxInput.value);
            const minDefault = parseFloat(minInput.getAttribute('min'));
            const maxDefault = parseFloat(maxInput.getAttribute('max'));
            
            // Convert to cents for Shopify
            const minValCents = Math.round(minVal * 100);
            const maxValCents = Math.round(maxVal * 100);
            const minDefaultCents = Math.round(minDefault * 100);
            const maxDefaultCents = Math.round(maxDefault * 100);
            
            if (minValCents !== minDefaultCents) {
              url.searchParams.set(minParam, minValCents);
            } else {
              url.searchParams.delete(minParam);
            }
            
            if (maxValCents !== maxDefaultCents) {
              url.searchParams.set(maxParam, maxValCents);
            } else {
              url.searchParams.delete(maxParam);
            }
            
            // Preserve sort parameter
            const currentSort = new URLSearchParams(window.location.search).get('sort_by');
            if (currentSort) {
              url.searchParams.set('sort_by', currentSort);
            }
            
            window.location.href = url.toString();
          }, 500);
        };
        
        minInput.addEventListener('change', (e) => {
          e.preventDefault();
          applyPriceFilter();
        });
        maxInput.addEventListener('change', (e) => {
          e.preventDefault();
          applyPriceFilter();
        });
      });
    }
    
    setupSort() {
      // Try to find sort select if not already found
      if (!this.sortSelect) {
        this.sortSelect = document.getElementById('sort-by');
      }
      
      if (!this.sortSelect) {
        return;
      }
      
      // Set current sort value from URL
      const urlParams = new URLSearchParams(window.location.search);
      const currentSort = urlParams.get('sort_by');
      if (currentSort) {
        this.sortSelect.value = currentSort;
      }
      
      // Handle sort change
      this.sortSelect.addEventListener('change', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const sortValue = this.sortSelect.value;
        const url = new URL(window.location);
        
        // Preserve all existing filter parameters
        const filterParams = new URLSearchParams();
        url.searchParams.forEach((value, key) => {
          if (key.startsWith('filter.')) {
            filterParams.append(key, value);
          }
        });
        
        // Clear all params
        url.search = '';
        
        // Re-add filter parameters first
        filterParams.forEach((value, key) => {
          url.searchParams.append(key, value);
        });
        
        // Update sort parameter
        if (sortValue && sortValue !== 'manual') {
          url.searchParams.set('sort_by', sortValue);
        }
        
        // Navigate to new URL
        window.location.href = url.toString();
      });
    }
  }
  
  // Initialize filters
  function initCollectionFilters() {
    const sortSelect = document.getElementById('sort-by');
    const filtersToggle = document.querySelector('[data-filters-toggle]');
    const priceRanges = document.querySelectorAll('[data-price-range]');
    
    if (sortSelect || filtersToggle || priceRanges.length > 0) {
      new CollectionFilters();
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCollectionFilters();
    });
  } else {
    initCollectionFilters();
  }
  
  // Currency is now handled server-side via Liquid snippet - no JavaScript needed
  
  // Simple price range filter - runs independently
  function initPriceFilter() {
    const priceRanges = document.querySelectorAll('[data-price-range]');
    priceRanges.forEach(function(priceRange) {
      const minInput = priceRange.querySelector('[data-min-input]');
      const maxInput = priceRange.querySelector('[data-max-input]');
      const minDisplay = priceRange.querySelector('[data-min-display]');
      const maxDisplay = priceRange.querySelector('[data-max-display]');
      
      if (!minInput || !maxInput) return;
      
      const formatCurrency = function(val) {
        return parseFloat(val).toFixed(2) + ' ⃁';
      };
      
      const updateDisplay = function() {
        if (minDisplay) minDisplay.textContent = formatCurrency(minInput.value);
        if (maxDisplay) maxDisplay.textContent = formatCurrency(maxInput.value);
      };
      
      // Initialize display with current slider values
      updateDisplay();
      
      const applyFilter = function() {
        const url = new URL(window.location);
        const minParam = minInput.name;
        const maxParam = maxInput.name;
        // Keep values in riyals (don't convert to cents)
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);
        const minDefault = parseFloat(minInput.min);
        const maxDefault = parseFloat(maxInput.max);
        
        const otherParams = new URLSearchParams();
        url.searchParams.forEach(function(value, key) {
          if (key.startsWith('filter.') && key !== minParam && key !== maxParam) {
            otherParams.append(key, value);
          }
        });
        
        url.search = '';
        otherParams.forEach(function(value, key) {
          url.searchParams.append(key, value);
        });
        
        if (minVal !== minDefault) url.searchParams.set(minParam, minVal);
        if (maxVal !== maxDefault) url.searchParams.set(maxParam, maxVal);
        
        const sort = new URLSearchParams(window.location.search).get('sort_by');
        if (sort) url.searchParams.set('sort_by', sort);
        
        window.location.href = url.toString();
      };
      
      let timer;
      const handleInput = function() {
        updateDisplay();
        clearTimeout(timer);
        timer = setTimeout(applyFilter, 800);
      };
      
      minInput.addEventListener('input', handleInput);
      maxInput.addEventListener('input', handleInput);
      minInput.addEventListener('change', applyFilter);
      maxInput.addEventListener('change', applyFilter);
      
      // Initialize display with current slider values
      updateDisplay();
      
      // Check URL for active price filters and update sliders if needed
      const urlParams = new URLSearchParams(window.location.search);
      const minParam = minInput.name;
      const maxParam = maxInput.name;
      const urlMin = urlParams.get(minParam);
      const urlMax = urlParams.get(maxParam);
      
      if (urlMin) {
        const minVal = parseFloat(urlMin);
        if (!isNaN(minVal)) {
          minInput.value = minVal;
          updateDisplay();
        }
      }
      
      if (urlMax) {
        const maxVal = parseFloat(urlMax);
        if (!isNaN(maxVal)) {
          maxInput.value = maxVal;
          updateDisplay();
        }
      }
    });
  }
  
  // Initialize price filter immediately and on DOM ready
  function initPriceFilterNow() {
    initPriceFilter();
    // Also initialize display for handlePriceRangeChange function
    const priceRanges = document.querySelectorAll('[data-price-range]');
    priceRanges.forEach(function(priceRange) {
      const minInput = priceRange.querySelector('[data-min-input]');
      const maxInput = priceRange.querySelector('[data-max-input]');
      const minDisplay = priceRange.querySelector('[data-min-display]');
      const maxDisplay = priceRange.querySelector('[data-max-display]');
      
      if (minInput && maxInput && minDisplay && maxDisplay) {
        const formatCurrency = function(val) {
          const num = parseFloat(val);
          if (isNaN(num)) return '0.00 ⃁';
          return num.toFixed(2) + ' ⃁';
        };
        minDisplay.textContent = formatCurrency(minInput.value);
        maxDisplay.textContent = formatCurrency(maxInput.value);
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceFilterNow);
  } else {
    initPriceFilterNow();
  }
  
  // Retry in case elements load late
  setTimeout(initPriceFilterNow, 100);
  setTimeout(initPriceFilterNow, 500);
  setTimeout(initPriceFilterNow, 1000);

  // Category filter is handled by the inline <script> tag above the {% javascript %} block.


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductPage {
    constructor() {
      this.thumbnails = document.querySelectorAll('[data-thumbnail]');
      this.mainImage = document.querySelector('[data-main-image]');
      this.quantityInput = document.querySelector('[data-quantity-input]');
      this.quantityMinus = document.querySelector('[data-quantity-minus]');
      this.quantityPlus = document.querySelector('[data-quantity-plus]');
      this.productForm = document.querySelector('.product-form');
      this.variantInputs = document.querySelectorAll('.product-form input[type="radio"][name*="options["], .product-form select[name*="options["]');
      
      // Load product JSON data
      const productJsonEl = document.querySelector('[data-product-json]');
      if (productJsonEl) {
        try {
          this.productData = JSON.parse(productJsonEl.textContent);
        } catch (e) {
          console.error('Failed to parse product JSON:', e);
          this.productData = { variants: [] };
        }
      } else {
        this.productData = { variants: [] };
      }
      
      // Store variant-image mappings
      this.variantImages = {};
      this.buildVariantImageMap();
      
      this.init();
    }
    
    buildVariantImageMap() {
      // Build map of variant IDs to images from JSON data
      this.variantImages = {};
      this.variantOptionsMap = {};
      
      if (this.productData && this.productData.variants) {
        console.log('Building variant maps from', this.productData.variants.length, 'variants');
        
        this.productData.variants.forEach(variant => {
          console.log('Processing variant:', variant.id, 'with options:', variant.option1, variant.option2, variant.option3);
          
          if (variant.featured_image) {
            console.log('Variant', variant.id, 'has featured image:', variant.featured_image.url);
            
            // Map by variant ID
            this.variantImages[variant.id] = {
              imageId: variant.featured_image.id,
              imageUrl: variant.featured_image.url,
              imageAlt: variant.featured_image.alt || ''
            };
            
            // Map by option values
            const optionKey = [
              variant.option1 || '',
              variant.option2 || '',
              variant.option3 || ''
            ].filter(v => v).join('|');
            
            if (optionKey) {
              this.variantOptionsMap[optionKey] = {
                variantId: variant.id,
                imageId: variant.featured_image.id,
                imageUrl: variant.featured_image.url,
                imageAlt: variant.featured_image.alt || ''
              };
            }
          }
        });
      }
      
      console.log('Variant images map:', this.variantImages);
      console.log('Variant options map:', this.variantOptionsMap);
    }
    
    init() {
      this.setupThumbnails();
      this.setupQuantity();
      this.setupVariantImageSwitching();
      this.setInitialVariantImage();
    }
    
    setInitialVariantImage() {
      // Set initial variant image on page load
      const variantIdInput = this.productForm?.querySelector('[data-variant-id]');
      if (variantIdInput) {
        const initialVariantId = parseInt(variantIdInput.value);
        if (initialVariantId && this.variantImages[initialVariantId]) {
          this.switchToImage(this.variantImages[initialVariantId]);
        }
      }
    }
    
    setupVariantImageSwitching() {
      if (!this.mainImage) return;
      
      // Listen to all variant option changes - use event delegation for dynamic content
      if (this.productForm) {
        this.productForm.addEventListener('change', (e) => {
          // Check if it's a variant option input (name contains "options[")
          if (e.target.matches('input[type="radio"][name*="options["], select[name*="options["]')) {
            console.log('Variant option changed:', e.target.name, e.target.value);
            setTimeout(() => {
              this.updateVariant();
            }, 50);
          }
        });
      }
      
      // Also listen directly to inputs
      this.variantInputs.forEach(input => {
        input.addEventListener('change', () => {
          console.log('Direct variant input change:', input.name, input.value);
          setTimeout(() => {
            this.updateVariant();
          }, 50);
        });
      });
    }
    
    updateVariant() {
      if (!this.productForm || !this.mainImage) {
        console.log('Missing productForm or mainImage');
        return;
      }
      
      // Re-query variant inputs to get fresh state
      const currentInputs = this.productForm.querySelectorAll('input[type="radio"][name*="options["]:checked, select[name*="options["]');
      
      // Get selected option values by position (1, 2, 3)
      const selectedByIndex = {};
      currentInputs.forEach(input => {
        const position = parseInt(input.dataset.optionPosition || '1', 10);
        if (input.value) {
          selectedByIndex[position] = input.value;
          console.log(`Option ${position}: ${input.value}`);
        }
      });
      
      console.log('Selected by index:', selectedByIndex);
      
      // Find matching variant from JSON data
      if (this.productData && this.productData.variants) {
        const matchingVariant = this.productData.variants.find(variant => {
          // Check if variant matches all selected option values
          for (const [indexStr, selectedValue] of Object.entries(selectedByIndex)) {
            const index = parseInt(indexStr, 10);
            const variantValue = variant[`option${index}`];
            if (selectedValue && variantValue !== selectedValue) {
              return false;
            }
          }
          return true;
        });
        
        if (matchingVariant) {
          console.log('Found matching variant:', matchingVariant);
          
          // Update hidden variant ID input
          const variantIdInput = this.productForm.querySelector('[data-variant-id]');
          if (variantIdInput) {
            variantIdInput.value = matchingVariant.id;
          }
          
          // Switch image if variant has featured image
          if (matchingVariant.featured_image && this.variantImages[matchingVariant.id]) {
            console.log('Switching to variant image:', this.variantImages[matchingVariant.id]);
            this.switchToImage(this.variantImages[matchingVariant.id]);
          } else {
            console.log('Variant has no featured image');
          }
        } else {
          console.log('No matching variant found');
        }
      }
    }
    
    switchToImage(imageData) {
      if (!this.mainImage) {
        console.log('No main image container found');
        return;
      }
      
      const mainImg = this.mainImage.querySelector('img');
      if (!mainImg) {
        console.log('No image element found in main image container');
        return;
      }
      
      if (!imageData || !imageData.imageUrl) {
        console.log('No image data provided', imageData);
        return;
      }
      
      console.log('Switching to image (variant):', imageData.imageUrl);
      
      // Fade out
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.3s ease';
      
      setTimeout(() => {
        // Remove srcset so the browser uses src only
        if (mainImg.hasAttribute('srcset')) {
          mainImg.removeAttribute('srcset');
        }
        
        mainImg.src = imageData.imageUrl;
        mainImg.alt = imageData.imageAlt || '';
        mainImg.style.opacity = '1';
      }, 150);
      
      // Update active thumbnail if exists
      if (imageData.imageId && this.thumbnails.length) {
        const matchingThumbnail = Array.from(this.thumbnails).find(thumb => {
          return parseInt(thumb.dataset.mediaId) === imageData.imageId;
        });
        
        if (matchingThumbnail) {
          this.thumbnails.forEach(thumb => thumb.classList.remove('product-thumbnail--active'));
          matchingThumbnail.classList.add('product-thumbnail--active');
        }
      }
    }
    
    setupThumbnails() {
      console.log('Setting up thumbnails. Found:', this.thumbnails.length);
      console.log('Main image element:', this.mainImage);
      
      if (!this.thumbnails.length || !this.mainImage) {
        console.log('Missing thumbnails or main image');
        return;
      }
      
      this.thumbnails.forEach((thumbnail, index) => {
        console.log(`Setting up thumbnail ${index}:`, thumbnail);
        
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          console.log('Thumbnail clicked:', thumbnail);
          
          // Remove active class from all thumbnails
          this.thumbnails.forEach(thumb => thumb.classList.remove('product-thumbnail--active'));
          
          // Add active class to clicked thumbnail
          thumbnail.classList.add('product-thumbnail--active');
          
          // Update main image
          const mediaId = thumbnail.dataset.mediaId;
          const fullImageUrl = thumbnail.dataset.fullImageUrl;
          const img = thumbnail.querySelector('img');
          
          console.log('=== Thumbnail Click ===');
          console.log('Media ID:', mediaId);
          console.log('Full image URL from data attribute:', fullImageUrl);
          console.log('Thumbnail img src:', img ? img.src : 'none');
          
          if (!this.mainImage) {
            console.error('Main image container not found');
            return;
          }
          
          const mainImg = this.mainImage.querySelector('img');
          if (!mainImg) {
            console.error('Main img element not found');
            return;
          }
          
          console.log('Current main image src:', mainImg.src);
          
          // Get the new image URL - prefer data attribute, fallback to manipulating thumbnail URL
          let newSrc = fullImageUrl;
          
          if (!newSrc) {
            console.log('No data-full-image-url, using thumbnail URL manipulation');
            if (!img) {
              console.error('No thumbnail image found');
              return;
            }
            
            // Get thumbnail URL and convert to full size
            newSrc = img.currentSrc || img.src;
            console.log('Thumbnail URL:', newSrc);
            
            // Handle protocol-relative URLs
            if (newSrc.startsWith('//')) {
              newSrc = window.location.protocol + newSrc;
            }
            
            // Remove width parameter and add 800px width
            try {
              const url = new URL(newSrc);
              url.searchParams.delete('width');
              url.searchParams.set('width', '800');
              newSrc = url.toString();
            } catch (e) {
              console.warn('URL parsing failed, using regex:', e);
              // Remove existing width parameters
              newSrc = newSrc.replace(/[?&]width=\d+/g, '');
              // Add new width parameter
              const separator = newSrc.includes('?') ? '&' : '?';
              newSrc = newSrc + separator + 'width=800';
            }
          }
          
          // Convert protocol-relative URL to absolute URL
          if (newSrc.startsWith('//')) {
            newSrc = window.location.protocol + newSrc;
          }
          
          console.log('Final new image URL:', newSrc);
          
          // Always update the image
          mainImg.style.opacity = '0';
          mainImg.style.transition = 'opacity 0.3s ease';
          
          setTimeout(() => {
            console.log('Setting image src to:', newSrc);
            
            // Remove srcset so the browser doesn't override src
            if (mainImg.hasAttribute('srcset')) {
              mainImg.removeAttribute('srcset');
            }
            
            // Always set the new src
            mainImg.src = newSrc;
            
            if (img) {
              mainImg.alt = img.alt || '';
            }
            
            mainImg.style.opacity = '1';
            console.log('Image updated successfully');
          }, 150);
        });
      });
    }
    
    setupQuantity() {
      if (!this.quantityInput) return;
      
      if (this.quantityMinus) {
        this.quantityMinus.addEventListener('click', () => {
          const currentValue = parseInt(this.quantityInput.value) || 1;
          if (currentValue > 1) {
            this.quantityInput.value = currentValue - 1;
          }
        });
      }
      
      if (this.quantityPlus) {
        this.quantityPlus.addEventListener('click', () => {
          const currentValue = parseInt(this.quantityInput.value) || 1;
          this.quantityInput.value = currentValue + 1;
        });
      }
      
      // Ensure minimum value is 1
      this.quantityInput.addEventListener('change', () => {
        const value = parseInt(this.quantityInput.value) || 1;
        if (value < 1) {
          this.quantityInput.value = 1;
        }
      });
    }
  }
  
  // Initialize product page
  document.addEventListener('DOMContentLoaded', () => {
    const productPage = new ProductPage();
    
    // Also listen for Shopify's variant change event if available
    if (window.Shopify && window.Shopify.onVariantChange) {
      window.Shopify.onVariantChange = function(variant) {
        if (variant && variant.featured_image) {
          const imageUrl = variant.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_800x.$1');
          productPage.switchToImage({
            imageUrl: imageUrl,
            imageAlt: variant.title || ''
          });
        }
      };
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-carousel-track]');
      this.prevBtn = element.querySelector('[data-carousel-prev]');
      this.nextBtn = element.querySelector('[data-carousel-next]');
      
      if (!this.track) return;
      
      // Check if RTL
      this.isRTL = document.documentElement.dir === 'rtl' || 
                   this.track.closest('[dir="rtl"]') !== null;
      
      // Calculate scroll amount based on first card width + gap
      this.scrollAmount = this.calculateScrollAmount();
      
      this.init();
    }
    
    calculateScrollAmount() {
      const firstCard = this.track.querySelector('.product-card');
      if (!firstCard) return 304; // Default: 280px card + 24px gap
      
      const cardStyle = window.getComputedStyle(firstCard);
      const cardWidth = firstCard.offsetWidth;
      const gap = parseInt(cardStyle.marginRight || '0') || 
                  parseInt(window.getComputedStyle(this.track).gap) || 24;
      
      return cardWidth + gap;
    }
    
    init() {
      this.setupNavigation();
      
      // Wait for layout to settle before checking visibility
      requestAnimationFrame(() => {
        this.updateArrowsVisibility();
      });
      
      // Update arrows on scroll (throttled for performance)
      let scrollTimeout;
      this.track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          this.updateArrowsVisibility();
        }, 10);
      }, { passive: true });
      
      // Recalculate scroll amount on resize
      let resizeTimeout;
      const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.scrollAmount = this.calculateScrollAmount();
          this.updateArrowsVisibility();
        }, 250);
      };
      window.addEventListener('resize', handleResize, { passive: true });
      
      // Touch/swipe support is native with overflow-x: auto
    }
    
    setupNavigation() {
      if (!this.prevBtn || !this.nextBtn) return;
      
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const amount = this.isRTL ? this.scrollAmount : -this.scrollAmount;
        this.scrollBy(amount);
      });
      
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const amount = this.isRTL ? -this.scrollAmount : this.scrollAmount;
        this.scrollBy(amount);
      });
    }
    
    scrollBy(amount) {
      // scrollBy automatically handles RTL direction correctly
      this.track.scrollBy({
        left: amount,
        behavior: 'smooth'
      });
    }
    
    updateArrowsVisibility() {
      if (!this.prevBtn || !this.nextBtn) return;
      
      const scrollLeft = this.track.scrollLeft;
      const scrollWidth = this.track.scrollWidth;
      const clientWidth = this.track.clientWidth;
      const maxScroll = Math.max(0, scrollWidth - clientWidth);
      
      let isAtStart, isAtEnd;
      const tolerance = 1;
      
      if (this.isRTL) {
        // In RTL, scrollLeft behavior varies by browser:
        // - Chrome/Edge: scrollLeft is 0 at logical start (right), maxScroll at logical end (left)
        // - Firefox: scrollLeft can be negative at logical start
        // We need to check both the actual scrollLeft and scroll position
        const isScrolledToStart = scrollLeft <= tolerance || (scrollLeft < 0 && Math.abs(scrollLeft) <= tolerance);
        const isScrolledToEnd = Math.abs(scrollLeft - maxScroll) <= tolerance || scrollLeft >= maxScroll - tolerance;
        
        // In RTL: start is right side (prev button), end is left side (next button)
        isAtStart = isScrolledToStart;
        isAtEnd = isScrolledToEnd;
      } else {
        // LTR: scrollLeft is 0 at start, maxScroll at end
        isAtStart = scrollLeft <= tolerance;
        isAtEnd = scrollLeft >= maxScroll - tolerance;
      }
      
      this.prevBtn.style.opacity = isAtStart ? '0.3' : '1';
      this.prevBtn.style.pointerEvents = isAtStart ? 'none' : 'auto';
      this.prevBtn.setAttribute('aria-disabled', isAtStart ? 'true' : 'false');
      
      this.nextBtn.style.opacity = isAtEnd ? '0.3' : '1';
      this.nextBtn.style.pointerEvents = isAtEnd ? 'none' : 'auto';
      this.nextBtn.setAttribute('aria-disabled', isAtEnd ? 'true' : 'false');
    }
  }
  
  // Initialize carousels
  const initCarousels = () => {
    const carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(carousel => {
      if (!carousel.dataset.initialized) {
        new ProductCarousel(carousel);
        carousel.dataset.initialized = 'true';
      }
    });
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  } catch(e) { console.error(e); }
})();
})();
